// extracted by mini-css-extract-plugin
export default {"footerDesktop":"FooterStyle_footerDesktop__f0XSV","divWrapper":"FooterStyle_divWrapper__eYep7","brDisplay":"FooterStyle_brDisplay__N1Dup"};